// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

const EventBus = {
    on(event: any, callback: any) {
        document && document.addEventListener(event, e => callback(e.detail));
    },
    dispatch(event: any, data: any) {
        document && document.dispatchEvent(new CustomEvent(event, { detail: data }));
    },
    remove(event: any, callback?: any) {
        document && document.removeEventListener(event, callback);
    },
};

export default EventBus;
